import type { ITGMetadata } from "@ceeferenderer/itg-renderer-sdk/model/itgMetadata.model";
import type { LoginResponse } from "@dotcom/oauthjs";

const convertToTrackingTag = (metaData: ITGMetadata, loginResponse: LoginResponse, itgName: string) => ({
  page: {
    category: {
      businessType: "resi",
      designType: "responsive",
      primaryCategory: "help & support",
      siteType: "selfservice",
      subCategory1: itgName,
    },
    codebase: {
      name: "h&s resi",
    },
    pageInfo: {
      language: "en",
      screenName: metaData.pageName,
    },
  },
  schemaVersion: 0.11,
  user: [
    {
      profile: [
        {
          profileInfo: {
            authGUID: loginResponse?.tokenInfo?.decodedToken
              ? loginResponse?.tokenInfo?.decodedToken["comcast:cet:auth-guid"]
              : "",
            custGUID: loginResponse?.tokenInfo?.decodedToken?.sub,
          },
        },
      ],
    },
  ],
});
let itgName = "";
export const buildTrackingTag = (metaData: ITGMetadata, loginResponse: LoginResponse): HTMLScriptElement => {
  const trackingTag = document.createElement("script");
  if (metaData.itgName) {
    itgName = metaData.itgName;
  }
  trackingTag.setAttribute("type", "tracking-data-digitalData");
  trackingTag.textContent = JSON.stringify(convertToTrackingTag(metaData, loginResponse, itgName));
  return trackingTag;
};
